import { render, staticRenderFns } from "./lay-container.vue?vue&type=template&id=0da0203d&scoped=true"
import script from "./lay-container.vue?vue&type=script&lang=js"
export * from "./lay-container.vue?vue&type=script&lang=js"
import style0 from "./lay-container.vue?vue&type=style&index=0&id=0da0203d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da0203d",
  null
  
)

export default component.exports